import React, { useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography, Divider, List, ListItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import HeaderPopup, { useHeaderPopupStyles } from "./headerPopup";
import { useLocalizedName } from "../../../globals/langHelpers";
import IconButton from "@material-ui/core/IconButton";
import CloseMenuIcon from "../../common/icons/closeMenuIcon";
import { requestAdditionalAction, saveAdditionalAction } from "../../../redux/additionalAction/additionalActionActions";

const messages = defineMessages({
    closeTooltip: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
});
const useStyles = makeStyles((theme) => ({
    additionalActionDropdown: {
        width: "380px",
        padding: "0px",
    },
    superTitle: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "14px",
        textAlign: "left",
        display: "block",
    },
    title: {
        color: "#111111",
        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "22px",
        textAlign: "left",
        display: "block",
    },
    statusHeader: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "13.8px",
        letterSpacing: "-0.15px",
        textAlign: "left",
        marginTop: "22px",
        display: "block",
    },
    closeButton: {
        position: "absolute",
        right: "5px",
        top: "0px",
        bottom: "25px",
        color: "var(--blue-bell)",
    },
    additionalactionButton: {
        width: "260px",
    },
    additionalActionsOptions: {
        height: "500px",
        overflow: "auto",
    },
}));

export const AdditionalActions = (props) => {
    const { onRemove, isAdmin = false } = props;
    const intl = useIntl();
    const classes = useStyles();
    const popupClasses = useHeaderPopupStyles();
    const { getLocalizedName } = useLocalizedName();

    const [additionalActionOptions, setAdditionActionOptions] = React.useState([{ value: null }, ...props.additionalActionsStatus]);
    const [selectedAdditionalAction, setSelectedAdditionAction] = React.useState({ value: null });

    // keep an instance of the popup component
    // so we can close when a user clicks on an action
    const popupRef = useRef(null);

    const closePopup = () => {
        if (popupRef.current !== null) {
            popupRef.current.close();
        }
    };

    React.useEffect(() => {
        props.requestAdditionalAction();
    }, []);

    React.useEffect(() => {
        if (props?.workOrder?.relatedIdInformation?.additionalAction) {
            setSelectedAdditionAction({
                label: props?.workOrder?.relatedIdInformation?.additionalAction[`name_${intl.locale}`],
                value: props?.workOrder?.relatedIdInformation?.additionalAction?.id,
                data: props?.workOrder?.relatedIdInformation?.additionalAction,
            });
        } else {
            setSelectedAdditionAction({ value: null });
        }
    }, [props?.workOrder?.relatedIdInformation]);

    React.useEffect(() => {
        setAdditionActionOptions([{ value: null }, ...props.additionalActionsStatus]);
    }, [props.additionalActionsStatus]);

    const handleSave = (selectedItem) => {
        const username = props?.userInfo?.preferred_username;
        props.saveAdditionalAction(selectedItem.value, props?.workOrder?.workorderData?.workOrderNumber, username, true);
        setSelectedAdditionAction(selectedItem);
        closePopup();
    };

    return (
        <div className={props.className}>
            {
                <HeaderPopup
                    id="work-order-actions"
                    ref={popupRef}
                    customStyle={true}
                    isAdmin={isAdmin}
                    icon={(open) =>
                        isAdmin ? (
                            <Button color="primary" endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                                <Typography className={classes.superTitle}>
                                    {selectedAdditionalAction.value === null && (
                                        <FormattedMessage
                                            id="admin.work-order-details.additional-action-title"
                                            defaultMessage="Additional action"
                                            description="Admin work order additional action title"
                                        />
                                    )}
                                    {selectedAdditionalAction.value !== null && getLocalizedName({ object: selectedAdditionalAction.data })}
                                </Typography>
                            </Button>
                        ) : (
                            ""
                        )
                    }>
                    {Object.keys(props?.workOrder?.workorderData)?.length !== 0 && (
                        <List aria-label="profile details" onClose={onRemove} className={classes.additionalActionDropdown}>
                            {selectedAdditionalAction.value !== null && (
                                <>
                                    <ListItem>
                                        <div>
                                            <Typography className={classes.superTitle}>
                                                <FormattedMessage
                                                    id="admin.work-order-details.additional-action-sub-title"
                                                    defaultMessage="Additional action:"
                                                    description="Admin work order additional action sub title"
                                                />
                                            </Typography>
                                            <Typography className={classes.title}>
                                                {getLocalizedName({ object: selectedAdditionalAction.data })}
                                            </Typography>
                                            <IconButton
                                                aria-label="close"
                                                className={classes.closeButton}
                                                onClick={() => {
                                                    closePopup();
                                                }}>
                                                <CloseMenuIcon title={intl.formatMessage(messages.closeTooltip)} />
                                            </IconButton>
                                        </div>
                                    </ListItem>
                                </>
                            )}
                            {selectedAdditionalAction.value == null && (
                                <>
                                    <ListItem>
                                        <div>
                                            <IconButton
                                                aria-label="close"
                                                className={classes.closeButton}
                                                onClick={() => {
                                                    closePopup();
                                                }}>
                                                <CloseMenuIcon title={intl.formatMessage(messages.closeTooltip)} />
                                            </IconButton>
                                        </div>
                                    </ListItem>
                                </>
                            )}
                            <ListItem>
                                <Typography className={classes.statusHeader}>
                                    <FormattedMessage
                                        id="work-order-actions.change-status-header"
                                        defaultMessage="Change Actions TO:"
                                        description="Work order actions change status header"
                                    />
                                </Typography>
                            </ListItem>
                            <div className={classes.additionalActionsOptions}>
                                {additionalActionOptions.map(
                                    (data) =>
                                        data.value !== null && (
                                            <ListItem key={data.value}>
                                                <button className={popupClasses.linkButton} type="button" onClick={() => handleSave(data)}>
                                                    <span>{getLocalizedName({ object: data.data })}</span>
                                                </button>
                                            </ListItem>
                                        ),
                                )}
                            </div>
                        </List>
                    )}
                </HeaderPopup>
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        additionalActionsStatus: state.additionalActions?.additionalActionStatus,
        userInfo: state.login.userInfo,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestAdditionalAction,
            saveAdditionalAction,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalActions);
